export function getHomeWidgetsEligibility({ areHomepageWidgetsDisabled, initialModeResolved, isIncognito, isMobileStyle, }) {
    return initialModeResolved && !areHomepageWidgetsDisabled && !isIncognito && !isMobileStyle;
}
//# sourceMappingURL=homeWidgetsEligibility.js.map